import React from "react";
import { CircularProgress } from "@material-ui/core";
import { createMarkup } from "../common";

const LoadingCard = props => {
    let text = null;
    let textarray = '';

    let color = "#00567a";
    if (typeof props.text !== 'undefined') {
        text = props.text;
    }

    if (typeof props.textarray !== 'undefined') {
        textarray = props.textarray;
    }

    if (typeof props.color !== 'undefined') {
        color = props.color;
    }


    return (
        <div
            style={{
                display: "flex",
                flexDirection:"column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                margin: "56px 0",
                backgroundColor: "white"
            }}
        >
            <CircularProgress style={{fontSize: "2em"}} className="text-blue margin-bottom-16"/>
            <>
                {text !== null
                    ? (
                        <h3 className="">{text}</h3>
                    ) : (
                        <div style={{ width: '75%', margin: '32px auto', textAlign: 'center', lineHeight: '1.3', fontSize: '0.85em', fontWeight: '400', minHeight: '150px' }} dangerouslySetInnerHTML={createMarkup(textarray)} />
                    )
                }
            </>
        </div>
    )
};

export { LoadingCard }
